export var PageLayoutType = /*#__PURE__*/function (PageLayoutType) {
  PageLayoutType["DEFAULT"] = "default";
  PageLayoutType["HEADER_FOOTER"] = "headerFooter";
  return PageLayoutType;
}({});
export var PageLayout = /*#__PURE__*/function (PageLayout) {
  PageLayout["DEFAULT"] = "default";
  PageLayout["HEADER_FOOTER"] = "headerFooter";
  PageLayout["NB_LAYOUT"] = "nbLayout";
  PageLayout["DP_LAYOUT"] = "dpLayout";
  return PageLayout;
}({});
export default {};